import { render, staticRenderFns } from "./CurlCard.vue?vue&type=template&id=a3599782&scoped=true"
import script from "./CurlCard.vue?vue&type=script&lang=js"
export * from "./CurlCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3599782",
  null
  
)

export default component.exports